__turbopack_context__.v({
  "bar": "BlogCover-module__pKfpsq__bar",
  "barPlayed": "BlogCover-module__pKfpsq__barPlayed",
  "cover": "BlogCover-module__pKfpsq__cover",
  "dot": "BlogCover-module__pKfpsq__dot",
  "dotLost": "BlogCover-module__pKfpsq__dotLost",
  "dotWon": "BlogCover-module__pKfpsq__dotWon",
  "dots": "BlogCover-module__pKfpsq__dots",
  "score": "BlogCover-module__pKfpsq__score",
  "scoreLabel": "BlogCover-module__pKfpsq__scoreLabel",
  "scores": "BlogCover-module__pKfpsq__scores",
  "tag": "BlogCover-module__pKfpsq__tag",
  "tags": "BlogCover-module__pKfpsq__tags",
  "toneBalance": "BlogCover-module__pKfpsq__toneBalance",
  "toneObjection": "BlogCover-module__pKfpsq__toneObjection",
  "tonePain": "BlogCover-module__pKfpsq__tonePain",
  "toneSignal": "BlogCover-module__pKfpsq__toneSignal",
  "toneSpeech": "BlogCover-module__pKfpsq__toneSpeech",
  "toneTrends": "BlogCover-module__pKfpsq__toneTrends",
  "tool": "BlogCover-module__pKfpsq__tool",
  "toolClaude": "BlogCover-module__pKfpsq__toolClaude",
  "toolHub": "BlogCover-module__pKfpsq__toolHub",
  "tools": "BlogCover-module__pKfpsq__tools",
  "wave": "BlogCover-module__pKfpsq__wave",
});
